import React from "react"
import { useFormContext, useForm, FormProvider } from "react-hook-form"

import { render, cleanup, waitFor } from "@testing-library/react"
import userEvent from "@testing-library/user-event"
import Pill from "../index"
afterEach(cleanup)

export const PillWithContext = (props) => {
  const methods = useForm()

  return (
    <FormProvider {...methods}>
      <form>
        <ConnectForm>{({ register }) => <Pill {...props} />}</ConnectForm>
      </form>
    </FormProvider>
  )
}

export const ConnectForm = ({ children }) => {
  const methods = useFormContext()

  return children({ ...methods })
}

describe("<Pill />", () => {
  it("shows pill", async () => {
    const tree = (
      <PillWithContext
        text="I am a pill"
        currentPillTextSelected="I am a pill"
        labelId="sample-pill"
        onPillChange={() => "hi"}
      />
    )

    const { getByLabelText } = render(tree)

    expect(getByLabelText("I am a pill")).toBeInTheDocument()
  })
  it("pill is unchecked by default", async () => {
    const { getByLabelText } = render(
      <PillWithContext text="n/a" labelId="sample-pill" onPillChange={() => "hi"} />
    )

    expect(getByLabelText("n/a")).not.toHaveAttribute("checked")
  })
  it("selects pill when it's clicked/changed", async () => {
    const { getByLabelText } = render(
      <PillWithContext
        text="possibly"
        currentPillTextSelected="possibly"
        pillGroupName="possible"
        labelId="sample-pill"
        onPillChange={() => "hi"}
      />
    )

    userEvent.click(getByLabelText("possibly"))
    await waitFor(() =>
      expect(getByLabelText("possibly").parentElement).toHaveClass("selected")
    )

    // native checked attribute is still checked (accessibility check)
    expect(getByLabelText("possibly")).toHaveAttribute("checked")
  })
})
